import React from 'react';
const AlertHigh = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: '0 0 32 32', fill: 'none' }, props),
    React.createElement("circle", { cx: 16, cy: 16, r: 12, fill: '#DB0000' }),
    React.createElement("path", { d: 'M15 10C15 9.44772 15.4477 9 16 9C16.5523 9 17 9.44772 17 10V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V10Z', fill: '#FFFFFF' }),
    React.createElement("circle", { cx: 16, cy: 21.5, r: 1.5, fill: '#FFFFFF' })));
export default AlertHigh;
//# sourceMappingURL=AlertHigh.svg.js.map